export const PDF_HIDDEN_CLASS = 'pdf-hidden';
